<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex class="d-flex justify-space-between mb-3 align-center" xs12>
        <h3 class="font-weight-bold">Working Visa Report</h3>
        <div class="text-xs-right">
          <export-excel-button
              :export-data="exportData"
              v-if="$oauth.checkIfHasPermission(['export traveller-scan-report'])"
          />
          <refresh-button :click-function="refreshData"></refresh-button>
        </div>
      </v-flex>

      <v-flex lg12>
        <v-card>
          <v-layout class="py-1 mx-2" row wrap>
            <v-flex xs4 class="pb-0">
              <v-text-field
                  flat
                  hide-details
                  placeholder="Search by typing here..."
                  prepend-inner-icon="search"
                  solo
                  v-model="filters.query"
                  @keypress.enter="fetchFiltersData"
              />
            </v-flex>

            <v-flex xs4 class="pb-0">
              <v-text-field
                  flat
                  hide-details
                  placeholder="Document Number"
                  prepend-inner-icon="filter_list"
                  solo
                  v-model="filters.document_number"
                  @keypress.enter="fetchFiltersData"
              />
            </v-flex>

            <v-flex xs4>
              <v-autocomplete
                  :items="countries"
                  chips
                  clearable
                  deletable-chips
                  flat
                  hide-details
                  item-text="country_name"
                  item-value="id"
                  label="Filter By Country"
                  multiple
                  prepend-inner-icon="filter_list"
                  solo
                  v-model="filters.country"
                  @change="fetchFiltersData"
              />
            </v-flex>
          </v-layout>

          <v-divider/>

          <v-card-text class="pa-0">
            <v-data-table
                :footer-props="footerProps"
                :headers="headers"
                :items="tableData"
                :loading="loading"
                class="elevation-0"
            >
                      <!-- :server-items-length="totalNumber"
                :options.sync="pagination" -->
              <!-- Serial Number -->
              <template v-slot:item.s_no="{ index }">
                <td>{{ (pagination.page - 1) * pagination.itemsPerPage + index + 1 }}</td>
              </template>

              <!-- Country with tooltip -->
              <template v-slot:item.country="{ item }">
                <td>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span v-on="on">{{ item.country }}</span>
                    </template>
                    <span>{{ item.country }}</span>
                  </v-tooltip>
                </td>
              </template>

              <!-- Action -->
              <template v-slot:item.action="{ item }">
                <td>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn
                          color="primary"
                          dark
                          dense
                          fab
                          x-small
                          v-on="on"
                          :to="'/system/travellers-history/view/' + item.id"
                      >
                        <v-icon small>remove_red_eye</v-icon>
                      </v-btn>
                    </template>
                    <span>View</span>
                  </v-tooltip>
                </td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { commonStoreMixin } from "../../mixins/commonStoreMixin";
import CustomDateRangePicker from "../../components/CustomDateRangePicker";
import ExportExcelButton from "../../components/ExportExcelButton";
import FlatDatePicker from "../../components/FlatDatePicker";
import RefreshButton from "@/components/RefreshButton";

export default {
  name: "WorkingVisaReport",  

  components: { RefreshButton, FlatDatePicker, CustomDateRangePicker, ExportExcelButton },

  mixins: [commonStoreMixin],

  data() {
    return {
      title: "Working Visa Report",
      filters: {
        query: '',
        document_number: '',
        country: []
      },
      headers: [
        { text: 'S.N.',              value: 's_no',               sortable: false },
        { text: "Full Name",         value: "full_name" },
        { text: "Country",           value: "country",       sortable: false }, 
        { text: "Visa Number",       value: "visa_number" },
        { text: "Document Number",   value: "document_number" },
        { text: "Submission Number", value: "submission_no",  sortable: false },
        { text: "Organization Name", value: "organization_name",  sortable: false },
        { text: "Approved On",        value: "approved_date" },
        { text: "Action",            value: "action",             sortable: false }
      ]
    };
  },

  computed: {
    tableData() {
      return this.$store.state.WorkingVisaReport.data || [];
    },
    totalNumber() {
      return this.$store.state.WorkingVisaReport.total || 0;
    },
    exportData() {
      return this.tableData;
    },
    ...mapGetters({
      loading: "WorkingVisaReport/reportLoading",
      countries: "CountryList/all",
    })
  },

  watch: {
    pagination: {
      deep: true,
      handler() {
        this.fetchData();
      }
    }
  },

  methods: {
    ...mapActions({
      fetchCountries: "CountryList/fetchAllCountries"
    }),

    fetchFiltersData() {
      this.pagination.page = 1;
      this.fetchData();
    },

    refreshData() {
      this.filters = { query: '', document_number: '', country: [] };
      this.pagination.page = 1;
      this.fetchData();
    },
  },

  mounted() {
    this.stateName   = 'WorkingVisaReport';           
    this.commonState = this.$store.state.WorkingVisaReport;
    this.fetchCountries();
    this.fetchData();                                
  }
};
</script>